export const HUB_SHOW_INACTIVE_KEY = 'hubShowInactiveNetworks';

export enum HubTab {
  Cards = 'cards',
  List = 'list',
  Map = 'map',
}
